/** Short-lived notifications (aria-live). */
import { h } from './dom';

export type ToastKind = 'info' | 'warn' | 'error';

const SHOW_MS = 2400;
const MAX = 3;

export class Toasts {
  readonly el = h('div', 'uz-toasts', { role: 'status', 'aria-live': 'polite' });

  show(text: string, kind: ToastKind = 'info'): void {
    // Same text already visible: restart instead of stacking duplicates.
    for (const t of Array.from(this.el.children) as HTMLElement[]) {
      if (t.textContent === text && !t.classList.contains('is-out')) t.remove();
    }
    while (this.el.children.length >= MAX) this.el.firstElementChild?.remove();
    const t = h('div', 'uz-toast', { 'data-kind': kind }, [text]);
    this.el.append(t);
    window.setTimeout(() => {
      t.classList.add('is-out');
      window.setTimeout(() => t.remove(), 300);
    }, SHOW_MS);
  }
}
